import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { Servidor } from '../_classes/servidor';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { FrqBancoHoras } from './../_classes/frq-banco-horas';
import { Util } from './../_classes/util';
import { ModalAlertaService } from './../shared/modal-alerta.service';

export class ItemGrafico {
  mesFechamento: Date = null;
  credito: number = 0;
  debito: number = 0;
}

@Component({
  selector: 'app-banco-horas',
  templateUrl: './banco-horas.component.html',
  styleUrls: ['./banco-horas.component.scss'],
})
export class BancoHorasComponent implements OnInit {
  private readonly recurso: string = 'banco-horas'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = [
    'dtOcorrencia',
    'dtValidade',
    'qtHoras',
    'tipoHoras.ds',
    'txObservacao',
  ];

  //servidor$: Observable<Servidor>;
  servidorTmp: Servidor = new Servidor();

  total: number = 0;
  simples = false;

  erros$ = new Subject<boolean>();
  dataSource$: Observable<FrqBancoHoras[]>;
  dataSource: MatTableDataSource<FrqBancoHoras>;

  //total:number = 0;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  itensAjuda = [
    {
      titulo: 'Data',
      texto: 'Data que aconteceu o fato gerador do crédito/débito',
    },
    {
      titulo: 'Validade',
      texto: 'Último dia que pode ser protocolado processo para usufruto',
    },
    {
      titulo: 'Minutos',
      texto: 'Quantidade de horas em minutos',
    },

    {
      titulo: 'Descrição',
      texto: 'Tipo de horas computadas, e descrição',
    },
    {
      titulo: 'Observações',
      texto: 'Observações acerca do item',
    },
  ];
  graficoValor: number[] = [0, 0];
  graficoAjuda: any = null;
  graficoEtiqueta: any = null;
  mostrarGrafico = false;
  graficoValorMaximo = 0;

  @ViewChild('pagS', { read: MatPaginator, static: true })
  paginatorS: MatPaginator;
  @ViewChild('matS', { read: MatSort, static: true }) sortS: MatSort;

  grafico2Itens: ItemGrafico[];
  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    title: {
      display: true,
      text: 'Gráfico dos últimos 12 registros de fechamento em minutos',
      fontSize: 24,
      fontFamily:
        '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
    },
  };
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;

  public barChartData: ChartDataSets[] = [
    { data: [], label: 'Crédito', backgroundColor: '#7FD13B' },
    { data: [], label: 'Débito', backgroundColor: '#e43737' },
  ];

  private t: any;

  totalC: number = 0;
  totalD: number = 0;

  largura() {
    if (Util.larguraDaTela() > 768) {
      return 600;
    } else {
      return 300;
    }
  }

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  desenharGrafico(credito: number, debito: number) {
    // é preciso mudar o esquema de cores do arquivo .\node_modules\jqwidgets-scripts\jqwidgets\jqxbargauge.js
    //{ name: 'scheme02', colors: ['#7FD13B', '#B22E2F', '#FEB80A', '#00ADDC', '#738AC8'] },
    this.graficoValor = new Array<number>();
    this.graficoValor.push(credito ? credito : 0);
    this.graficoValor.push(debito ? debito : 0);

    this.graficoValorMaximo = credito > debito ? credito : debito;

    //console.log('valores do grafico (C,D)', credito, debito);

    this.graficoEtiqueta = {
      formatFunction: (value: number, i: number): string => {
        let tipo = '';
        if (i === 0) {
          tipo = 'C';
        } else if (i === 1) {
          tipo = 'D';
        }

        return tipo;
      },
      precision: 15,
      indent: 0,
    };

    this.graficoAjuda = {
      visible: true,
      formatFunction: (value: string, i: number) => {
        let tipo = '';
        if (i === 0) {
          tipo = ' créd';
        } else if (i === 1) {
          tipo = ' déb';
        }
        return 'Total ' + tipo + '<br>' + this.minutosEmHoras(parseInt(value));
      },
    };

    this.mostrarGrafico = true;
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  minutosEmHoras(min: number) {
    let r: string = '';
    //console.log('minutos', min);
    if (!min) {
      min = 0;
    }

    if (min === 0) {
      r = '0';
    } else {
      const horas: number = Math.floor(min / 60);
      r =
        new String(horas).padStart(2, '0') +
        ':' +
        new String(min - horas * 60).padStart(2, '0');
      /*Util.padLeft(horas, '0', 2) +
        ':' +
        Util.padLeft(min - horas * 60, '0', 2);*/
    }

    return r;
  }

  ngOnInit() {
    console.log('iniciando');
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
    //this.carregando = false;
  }*/

  executarAoCarregarDatasource(x: FrqBancoHoras[]) {
    this.dataSource = new MatTableDataSource<FrqBancoHoras>(x);
    console.log('executarAoCarregarDatasource');
    x.forEach((y: FrqBancoHoras) => {
      if (y.tipoHoras) {
        if (y.tipoHoras.tpOperacao === 'CRE') {
          this.totalC = this.totalC + y.qtHoras;
        } else {
          this.totalD = this.totalD - y.qtHoras;
        }
      }
    });

    this.atualizarGrafico2(x);

    //console.log('grafico2_itens', this.grafico2_itens);

    if (this.totalD < 0) {
      this.totalD = this.totalD * -1;
    }

    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.atualizarPaginador();
    this.desenharGrafico(this.totalC, this.totalD);
    this.carregando = false;
  }

  atualizarPaginador() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginatorS;
      this.dataSource.sort = this.sortS;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
  }

  atualizarGrafico2(x: FrqBancoHoras[]) {
    this.grafico2Itens = new Array<ItemGrafico>();
    //https://medium.com/codingthesmartway-com-blog/angular-chart-js-with-ng2-charts-e21c8262777f$ npm install chart.js
    //npm install ng2-charts@2.2.3

    x.forEach((y: FrqBancoHoras) => {
      //console.log('y', y);
      //this.graficoValor.push(credito ? credito : 0);
      let usado: boolean = false;
      if (y.fechamento) {
        //if (y.fechamento.dtIniPeriodo > Util.somarDias(new Date(), -365)) {
        this.grafico2Itens.forEach((item: ItemGrafico) => {
          if (item.mesFechamento === y.fechamento.dtIniPeriodo) {
            if (y.tipoHoras.tpOperacao === 'CRE') {
              item.credito = item.credito + y.qtHoras;
            } else {
              item.debito = item.debito + y.qtHoras;
            }
            usado = true;
          }
        });
        if (!usado) {
          let i = new ItemGrafico();
          i.mesFechamento = y.fechamento.dtIniPeriodo;
          if (y.tipoHoras.tpOperacao === 'CRE') {
            i.credito = y.qtHoras;
          } else {
            i.debito = y.qtHoras;
          }
          this.grafico2Itens.push(i);
          usado = true;
        }
        //}
      }
    });
    let cred: number[] = new Array<number>();
    let deb: number[] = new Array<number>();

    this.grafico2Itens = this.grafico2Itens.sort(function (a, b) {
      if (a.mesFechamento < b.mesFechamento) return -1;
      if (a.mesFechamento > b.mesFechamento) return 1;
      return 0;
    });
    let qtde: number = this.grafico2Itens.length;
    let iX: number = 0;
    this.grafico2Itens.forEach((item: ItemGrafico) => {
      iX++;
      if (iX + 12 > qtde) {
        this.barChartLabels.push(
          Util.dataMesAbrev(item.mesFechamento).substring(3, 10)
        );
        cred.push(item.credito);
        deb.push(item.debito);
      }
    });

    this.barChartData[0].data = cred;
    this.barChartData[1].data = deb;
    this.barChartData[0].backgroundColor = '#7FD13B';
    this.barChartData[1].backgroundColor = '#e43737';
    this.barChartData[0].hoverBackgroundColor = '#75c037';
    this.barChartData[1].hoverBackgroundColor = '#c93838';
    this.barChartData[0].label = 'Crédito';
    this.barChartData[1].label = 'Débito';
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  dataEhPassada(d): boolean {
    return Util.dataEhValida(new Date(), new Date(d));
  }

  atualizar() {
    console.log('atualizar');
    this.carregando = true;

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      console.log('getServidorComFuncao2');
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    console.log('lsitar');
    this.servidorTmp = new Servidor(this.env.servidor);
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dataSource$ = this.service
      .listarFrqBancoHoras(this.env.servidor.nrMatricula)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  alterarLoading() {
    this.carregando = !this.carregando;
  }

  handleError(e) {
    if (e) {
      //console.log('handleError', e);
      this.erros$.next(true);
      this.alertService.mostrarAlertaPerigo(
        'Erro, tente novamente mais tarde',
        e
      );
    }
  }
}
